/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo, type MemoExoticComponent, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import EmptyState from '@atlaskit/empty-state/empty-state';
import Link from '@atlaskit/link/link';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PreviewPanel, PreviewPanelBody, PreviewPanelHeader, PreviewPanelTitle } from '@atlassian/preview-panel';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';
import ErrorGeneric from '../assets/ErrorGeneric.svg';
import { messages } from './messages';
const styles = {
  body: "_0LQT5EGXk2 _03SyCPGXk2 _46hvQmNHnM _0xmtkoNHnM"
};
type Props = {
  icon: ReactNode;
  name: string;
  url: string;
};
export const ErrorFallbackPreviewPanel: MemoExoticComponent<({
  url,
  name,
  icon
}: Props) => JSX.Element> = memo(({
  url,
  name,
  icon
}: Props): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const {
    close
  } = usePreviewPanelsActions();
  return <PreviewPanel>
			<PreviewPanelHeader onClose={close} url={url}>
				<PreviewPanelTitle title={name} icon={icon} />
			</PreviewPanelHeader>
			<PreviewPanelBody styles={styles.body}>
				<EmptyState header={formatMessage(messages.errorHeader)} description={formatMessage(messages.errorDescription, {
        link: (chunks: ReactNode) => <Link href="https://status.atlassian.com/">{chunks}</Link>
      })} headingLevel={2} imageUrl={ErrorGeneric} />
			</PreviewPanelBody>
		</PreviewPanel>;
});